import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';

const STATUS_LABELS = {
	'4': 'Good',
	'5': 'Incomplete',
	'6': 'Failed',
	'7': 'Error'
};

const STATUS_COLORS = {
	'4': '#198754',
	'5': '#fd7e14',
	'6': '#dc3545',
	'7': '#6c757d'
};

const StatsStatusBreakdown = ({ breakdown }) => {
	if (!breakdown || Object.keys(breakdown).length === 0) {
		return <p className='text-center text-muted mt-3'>No status data available</p>;
	}

	const chartData = Object.entries(breakdown).map(([status, count]) => ({
		name: STATUS_LABELS[status] || `Status ${status}`,
		value: count,
		color: STATUS_COLORS[status] || '#adb5bd'
	}));

	return (
		<ResponsiveContainer width='100%' height={280}>
			<PieChart>
				<Pie
					data={chartData}
					cx='50%'
					cy='50%'
					innerRadius={60}
					outerRadius={100}
					paddingAngle={2}
					dataKey='value'
					label={({ name, percent }) => `${name} ${(percent * 100).toFixed(1)}%`}
				>
					{chartData.map((entry, index) => (
						<Cell key={`cell-${index}`} fill={entry.color} />
					))}
				</Pie>
				<Tooltip formatter={(value) => value.toLocaleString('es-MX')} />
				<Legend />
			</PieChart>
		</ResponsiveContainer>
	);
}

StatsStatusBreakdown.propTypes = {
	breakdown: PropTypes.object
}

export default StatsStatusBreakdown;
